import React, { useEffect } from 'react'
import Aos from "aos";
import "aos/dist/aos.css";
function YostelBlogs() {
   useEffect(() => {
            Aos.init({
              duration: 1000, // Animation duration
              easing: "ease-in-out", // Animation easing
              once: true, // Animation happens only once when scrolled into view
            });
          }, []);
 return (
  
   <>
     <div className="flex flex-col  items-center sm:px-16 p-6">
       <h1 className="text-[1.9rem] font-bold tracking-wide ">
         <span className="text-[#01A7D1] " data-aos="fade-right">Yostel</span> Blogs
       </h1>
       <p className="text-sm  text-[#444444] tracking-wide pt-3 text-center xl:w-[70%]" data-aos="fade-left">
         In publishing and graphic design, Lorem ipsum is a placeholder text
         commonly used to demonstrate the visual form of a document or a
         typeface without relying on meaningful content. 
       </p>
     </div>
   </>
 );
}

export default YostelBlogs
